import LogCenter, {
	CDPSender,
	DirectStrategy,
	MemoryStorage,
} from '@deezer/logcenter';
import type {PayLoad} from '@deezer/logcenter/build/types';
import type {CdpOptions} from '@deezer/logcenter/build/types/Sender/CDPSender/types';
import config from '@deezer/next/services/config';
import ExtendedCDP from './ExtendedCDP';

const apiKey = config.get('segment_api_key');
const cdpOptions: Partial<CdpOptions> = {
	filter: true,
	filterFunction: () => true,
	// eslint-disable-next-line no-console
	logger: (...args) => console.log(...args),
	stack: 'web',
};

// keep track of all the events sent before CDP is set up
// Once CDP is set up, all events are sent
let preInitPayloads: PayLoad[] = [];

export let cdp: ExtendedCDP;
export let logCenter: LogCenter = {
	log: payload => {
		// eslint-disable-next-line no-console
		console.log('pushing new pre init payload', payload);
		preInitPayloads.push(payload);
		return Promise.resolve();
	},
	strategies: [],
	storage: new MemoryStorage(),
};

const cdpConfiguration = {
	handledLogTypes: ['cdp'],
};

export const initLogCenter = async () => {
	// Don't instantiate the logger if it's on server side
	if (typeof window === 'undefined') {
		return;
	}
	try {
		cdp = new ExtendedCDP(apiKey, cdpOptions);
		cdp.init();
		const memoryStorage = new MemoryStorage();
		const cdpSender = new CDPSender(cdp);
		const cdpStrategy = new DirectStrategy(
			cdpSender,
			memoryStorage,
			cdpConfiguration,
		);

		logCenter = new LogCenter([cdpStrategy], memoryStorage);

		// Send all pre initialisation events
		if (preInitPayloads.length > 0) {
			// eslint-disable-next-line no-console
			console.log('Sending pre init payloads', preInitPayloads);
			preInitPayloads.forEach(payload => logCenter.log(payload));
			preInitPayloads = [];
		}
	} catch (e) {
		// eslint-disable-next-line no-console
		console.error(e, 'Cannot load Segment SDK');
	}
};

export {logCenter as default};
